import { I18n } from '@calendly/i18n'
import { BatchAction } from '@calendly/table'
import { useDispatch, useSelector } from 'react-redux'

import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade'

import { canRemoveInvitations } from './selectors'
import { openBatchRemoveInvitationsPopup, batchResendInvitations } from './slice'

export const PendingBatchControls = () => {
  const dispatch = useDispatch()
  const canRemove = useSelector(canRemoveInvitations)
  const enforceUpgrade = useEnforceUpgrade('organization_invitation', { skipPreface: true })

  const handleRemove = () => dispatch(openBatchRemoveInvitationsPopup())
  const handleResend = () => enforceUpgrade(() => dispatch(batchResendInvitations()))

  return (
    <>
      {canRemove && (
      <BatchAction onClick={handleRemove}>
        {I18n.t('publisher.organization.members.remove')}
      </BatchAction>
      )}
      <BatchAction onClick={handleResend}>
        {I18n.t('publisher.organization.members.resend_invite')}
      </BatchAction>
    </>
  )
}
